/* eslint-disable */ import { applicationConfigComponent, assertBoolean, assertNumber, attributeSelectionComponent, attributeSwitchComponent, canvasConfigComponent, canvasCustomEnvironmentComponent, composedOfComponent, fitRootPerspectiveCameraComponent, genericDimensionComponent, materialSwatchComponent, memoEval, navigationStepsComponent, priceComponent, sketchingComponent, sketchingDrawComponent, sketchingEditComponent, toolControlsComponent, universalSidebarFooterComponent, viewControlsComponent, violationsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { FinishType, FixingSystemType, HandrailType, MetalPostStyleType, PostStainlessFinishType, PostType, ThinIntermediatePostType } from '../model/index.js';
export const deckComponents = [
    attachComponent.withComponent(composedOfComponent, '$items', true).withEntity('Deck').attach(memoEval((self)=>self.$items.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'main', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Properties',
            'Summary',
            'Finalize'
        ],
        modes: [
            'owner'
        ]
    }).attach(memoEval(()=>[], ()=>({
            availableDimensions: [
                'cm'
            ],
            chatEnabled: false,
            indicatorSwitch: false,
            initialIndicatorShown: true,
            miniSidebar: false,
            shareStrategy: 'current-frontend',
            splitSidebar: true
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'build', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        modes: [
            'owner'
        ]
    }).attach(memoEval(()=>[], ()=>({
            availableDimensions: [
                'cm'
            ],
            chatEnabled: false,
            indicatorSwitch: false,
            initialIndicatorShown: true,
            miniSidebar: true,
            shareStrategy: 'current-frontend',
            splitSidebar: true
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'read', true).withEntity('Deck').withGradualFilter({
        modes: [
            'read'
        ]
    }).attach(memoEval(()=>[], ()=>({
            availableDimensions: [
                'cm'
            ],
            chatEnabled: false,
            indicatorSwitch: false,
            initialIndicatorShown: true,
            miniSidebar: false,
            shareStrategy: 'current-frontend',
            splitSidebar: true
        }))),
    attachComponent.withComponent(canvasConfigComponent, 'default', true).withEntity('Deck').attach(memoEval(()=>[], ()=>({
            alpha: true,
            antialias: true,
            highlightingDisabled: true,
            logarithmicDepthBuffer: true,
            preserveDrawingBuffer: true
        }))),
    attachComponent.withComponent(canvasCustomEnvironmentComponent, 'default', true).withEntity('Deck').attach(memoEval(()=>[], ()=>({
            name: 'SceneEnvironment'
        }))),
    attachComponent.withComponent(navigationStepsComponent, 'main', true).withEntity('Deck').attach(memoEval(()=>[], ()=>({
            steps: [
                {
                    label: 'Design',
                    navigationStates: [
                        'Build'
                    ]
                },
                {
                    label: 'Select Products',
                    navigationStates: [
                        'Properties'
                    ]
                },
                {
                    label: 'Summary',
                    navigationStates: [
                        'Summary'
                    ]
                }
            ]
        }))),
    attachComponent.withComponent(universalSidebarFooterComponent, 'main', true).withEntity('Deck').attach(memoEval(()=>[], ()=>({}))),
    attachComponent.withComponent(viewControlsComponent, 'selection', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        toolStates: [
            'Selection'
        ]
    }).attach(memoEval(()=>[], ()=>({
            items: [
                {
                    label: 'Floor Plan',
                    icon: 'GridFour',
                    value: 'FloorPlan'
                },
                {
                    label: '3D View',
                    icon: 'Cube',
                    value: '3dView'
                }
            ]
        }))),
    attachComponent.withComponent(viewControlsComponent, 'readMode', true).withEntity('Deck').withGradualFilter({
        modes: [
            'read'
        ]
    }).attach(memoEval(()=>[], ()=>({
            items: [
                {
                    label: 'Floor Plan',
                    icon: 'GridFour',
                    value: 'FloorPlan'
                },
                {
                    label: '3D View',
                    icon: 'Cube',
                    value: '3dView'
                }
            ]
        }))),
    attachComponent.withComponent(priceComponent, 'main', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$price
        ], ($price)=>({
            price: $price,
            currency: 'USD'
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'finalize', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Finalize'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 1,
            near: 10,
            far: 50000,
            polarAngle: 1.3,
            azimuthAngle: 0.2
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, '3d', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Build',
            'Properties',
            'Summary'
        ],
        viewStates: [
            '3dView'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 1,
            near: 10,
            far: 50000,
            polarAngle: 1.3,
            minPolarAngle: 0.5,
            maxPolarAngle: 1.5
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'floorPlan', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Build',
            'Properties',
            'Summary'
        ],
        viewStates: [
            'FloorPlan'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 1,
            near: 10,
            far: 50000,
            minDistance: 500,
            maxDistance: 40000,
            polarAngle: 0,
            minPolarAngle: 0,
            maxPolarAngle: 0,
            azimuthAngle: 0
        }))),
    attachComponent.withComponent(toolControlsComponent, 'default', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        modes: [
            'owner'
        ]
    }).attach(memoEval(()=>[], ()=>({
            items: [
                {
                    label: 'Sketch / Outline Mode - Design your straight and stair balustrade sections then adjust to exact measurements using Fine Tune mode.',
                    value: 'Sketching',
                    icon: 'BoundingBox'
                },
                {
                    label: 'Selection / Fine Tune Mode - Adjust your balustrade with precision. Edit angles, enter exact lengths, add stair goings and risers, or delete sections for full control.',
                    value: 'Selection',
                    icon: 'CursorClick'
                }
            ]
        }))),
    attachComponent.withComponent(genericDimensionComponent, 'wires', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.numberOfWires
        ], (numberOfWires)=>({
            value: numberOfWires,
            min: 1,
            max: 25,
            decimalPlaces: 0,
            unit: 'wires'
        })), (state)=>{
        assertNumber(state.value);
        return {
            numberOfWires: state.value
        };
    }),
    attachComponent.withComponent(attributeSwitchComponent, 'useThinIntermediatePosts', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.useThinIntermediatePosts
        ], (useThinIntermediatePosts)=>({
            value: useThinIntermediatePosts
        })), (state)=>{
        assertBoolean(state.value);
        return {
            useThinIntermediatePosts: state.value
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'finish', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.finish,
            self.$finishSwatches
        ], (finish, $finishSwatches)=>({
            selectedSwatchKey: finish,
            swatches: $finishSwatches
        })), (state)=>{
        FinishType.assert(state.selectedSwatchKey);
        return {
            finish: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'thinIntermediatePostType', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.thinIntermediatePostType,
            self.$thinIntermediatePostSwatches
        ], (thinIntermediatePostType, $thinIntermediatePostSwatches)=>({
            selectedSwatchKey: thinIntermediatePostType,
            swatches: $thinIntermediatePostSwatches
        })), (state)=>{
        ThinIntermediatePostType.assert(state.selectedSwatchKey);
        return {
            thinIntermediatePostType: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'postStainlessFinish', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.postStainlessFinish
        ], (postStainlessFinish)=>({
            selectedSwatchKey: postStainlessFinish,
            swatches: {
                Satin: {
                    thumbnailUrl: '/images/swatches/metalSatin.jpg',
                    color: '#b4bdc7',
                    swatchName: 'Satin Finish'
                },
                Mirror: {
                    thumbnailUrl: '/images/swatches/metalMirrorPolish.jpg',
                    color: '#f0f2f4',
                    swatchName: 'Mirror Polish'
                }
            }
        })), (state)=>{
        PostStainlessFinishType.assert(state.selectedSwatchKey);
        return {
            postStainlessFinish: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'postType', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.postType
        ], (postType)=>({
            value: postType,
            options: [
                {
                    label: 'Timber',
                    value: 'Timber'
                },
                {
                    label: 'Metal',
                    value: 'Metal'
                }
            ]
        })), (state)=>{
        PostType.assert(state.value);
        return {
            postType: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'metalFixingSystem', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.fixingSystem
        ], (fixingSystem)=>({
            value: fixingSystem,
            options: [
                {
                    label: 'Toggle Lock',
                    value: 'ToggleLock'
                },
                {
                    label: 'Metal Insert',
                    value: 'MetalInsert'
                },
                {
                    label: 'Rig Fork with Nutserts',
                    value: 'RigForkWithNutserts'
                },
                {
                    label: 'Rig Fork with Saddles',
                    value: 'RigForkWithSaddles'
                }
            ]
        })), (state)=>{
        FixingSystemType.assert(state.value);
        return {
            fixingSystem: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'timberFixingSystem', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.fixingSystem
        ], (fixingSystem)=>({
            value: fixingSystem,
            options: [
                {
                    label: 'Rig Fork with Saddles',
                    value: 'ForkWithSaddles'
                },
                {
                    label: 'Rig Fork with Screw Eyes',
                    value: 'ForkWithScrewEyes'
                },
                {
                    label: 'Timber Insert',
                    value: 'TimberInsert'
                }
            ]
        })), (state)=>{
        FixingSystemType.assert(state.value);
        return {
            fixingSystem: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'postStyle', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.postStyle
        ], (postStyle)=>({
            value: postStyle,
            options: [
                {
                    label: 'Round stainless',
                    value: 'RoundStainless'
                },
                {
                    label: 'Square stainless',
                    value: 'SquareStainless'
                },
                {
                    label: 'Square aluminium',
                    value: 'SquareAlu'
                },
                {
                    label: 'I will supply my own metal posts',
                    value: 'Custom'
                }
            ]
        })), (state)=>{
        MetalPostStyleType.assert(state.value);
        return {
            postStyle: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'handrailType', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.handrailType
        ], (handrailType)=>({
            value: handrailType,
            options: [
                {
                    label: 'Flat timber (not supplied)',
                    value: 'FlatTimber'
                },
                {
                    label: 'Round stainless',
                    value: 'RoundStainless'
                },
                {
                    label: 'Square stainless',
                    value: 'SquareStainless'
                }
            ]
        })), (state)=>{
        HandrailType.assert(state.value);
        return {
            handrailType: state.value
        };
    }),
    attachComponent.withComponent(sketchingComponent, 'main', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$sketchingRecipes
        ], ($sketchingRecipes)=>({
            key: 'main',
            surface: {
                key: 'main',
                normal: {
                    x: 0,
                    y: 1,
                    z: 0
                },
                constant: 0
            },
            disableDepthControl: true,
            fontSize: 140,
            arrowHeadSize: 100,
            arcDiameter: 800,
            extrusionLength: 1000,
            angleSnapValue: 0.78539816339,
            distanceSnapValue: 50,
            recipes: $sketchingRecipes
        }))),
    attachComponent.withComponent(sketchingComponent, 'view', true).withEntity('Deck').attach(memoEval(()=>[], ()=>({
            key: 'viewmode',
            surface: {
                key: 'viewmode',
                normal: {
                    x: 0,
                    y: 1,
                    z: 0
                },
                constant: 0
            },
            disableDepthControl: true,
            fontSize: 140,
            arrowHeadSize: 100,
            arcDiameter: 800,
            extrusionLength: 1000,
            angleSnapValue: 0.78539816339,
            distanceSnapValue: 50,
            recipes: []
        }))),
    attachComponent.withComponent(sketchingDrawComponent, 'view', true).withEntity('Deck').withGradualFilter({
        modes: [
            'read'
        ]
    }).attach(memoEval(()=>[], ()=>({
            key: 'viewmode'
        }))),
    attachComponent.withComponent(sketchingDrawComponent, 'main', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        viewStates: [
            'FloorPlan'
        ],
        toolStates: [
            'Sketching'
        ],
        modes: [
            'owner'
        ]
    }).attach(memoEval(()=>[], ()=>({
            key: 'main'
        }))),
    attachComponent.withComponent(sketchingEditComponent, 'main', true).withEntity('Deck').withGradualFilter({
        navigationStates: [
            'Build'
        ],
        viewStates: [
            'FloorPlan'
        ],
        toolStates: [
            'Selection'
        ],
        modes: [
            'owner'
        ]
    }).attach(memoEval(()=>[], ()=>({
            key: 'main'
        }))),
    attachComponent.withComponent(violationsComponent, 'default', true).withEntity('Deck').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$violations
        ], ($violations)=>({
            violations: $violations
        })))
];

//# sourceMappingURL=deck.js.map